import { z } from 'zod'

import { UnhandledUnionError } from '@mntn-dev/utilities'
import type { ZodInfer } from '@mntn-dev/utility-types'

import type { SurveySubjectId } from './common.ts'
import { LegacyQuickframeMakerRatingSurveyDetailsSchema } from './legacy-quickframe-maker-rating.ts'
import { MakerBidAcceptedByBrandSurveyDetailsSchema } from './maker-bid-accepted-by-brand.ts'
import { MakerBidRejectedByBrandSurveyDetailsSchema } from './maker-bid-rejected-by-brand.ts'
import { OpportunityToBidAcceptedByMakerSurveyDetailsSchema } from './opportunity-to-bid-accepted-by-maker.ts'
import { OpportunityToBidDeclinedByMakerSurveyDetailsSchema } from './opportunity-to-bid-declined-by-maker.ts'
import { ProjectCompletedBrandReviewsMakerSurveyDetailsSchema } from './project-completed-brand-reviews-maker.ts'
import { ProjectCompletedMakerReviewsBrandSurveyDetailsSchema } from './project-completed-maker-reviews-brand.ts'
import type { SurveyType } from './survey-types.ts'

export const SurveyDetailsSchema = z.discriminatedUnion('surveyType', [
  MakerBidAcceptedByBrandSurveyDetailsSchema,
  MakerBidRejectedByBrandSurveyDetailsSchema,
  LegacyQuickframeMakerRatingSurveyDetailsSchema,
  OpportunityToBidAcceptedByMakerSurveyDetailsSchema,
  OpportunityToBidDeclinedByMakerSurveyDetailsSchema,
  ProjectCompletedBrandReviewsMakerSurveyDetailsSchema,
  ProjectCompletedMakerReviewsBrandSurveyDetailsSchema,
])

export type SurveyDetails = ZodInfer<typeof SurveyDetailsSchema>

export const UnwrappedSurveyDetails = (
  details: SurveyDetails
): [SurveySubjectId, SurveyType] => {
  const { surveyType } = details

  switch (surveyType) {
    case 'maker-bid-accepted-by-brand':
    case 'maker-bid-rejected-by-brand':
    case 'opportunity-to-bid-accepted-by-maker':
    case 'opportunity-to-bid-declined-by-maker': {
      return [details.bidId, surveyType]
    }
    case 'legacy-quickframe-maker-rating': {
      return [details.agencyTeamId, surveyType]
    }
    case 'project-completed-brand-reviews-maker':
    case 'project-completed-maker-reviews-brand': {
      return [details.projectId, surveyType]
    }
    default: {
      throw new UnhandledUnionError(surveyType)
    }
  }
}
